import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { format } from "date-fns";
import { GripVertical, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { SavedView } from "@/hooks/useViews";

interface SortableFilterRowProps {
  view: SavedView;
  onOpen: (id: string) => void;
  onDelete: (id: string) => void;
}

export function SortableFilterRow({ view, onOpen, onDelete }: SortableFilterRowProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: view.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center justify-between p-3 rounded-lg border bg-card hover:bg-accent/50 transition-colors"
    >
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <button
          type="button"
          className="cursor-grab text-muted-foreground hover:text-foreground touch-none"
          aria-label="Drag to reorder filter"
          {...attributes}
          {...listeners}
        >
          <GripVertical className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={() => onOpen(view.id)}
          className="font-medium text-left hover:underline cursor-pointer truncate"
        >
          {view.name}
        </button>
        <span className="text-sm text-muted-foreground whitespace-nowrap">
          {format(new Date(view.created_at), 'MMM d, yyyy')}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="text-destructive"
          onClick={() => onDelete(view.id)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
